import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeAll16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEdgeAll16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.023 2.91a.5.5 0 1 0 0-1h-6a.5.5 0 1 0 0 1zM2.933 5a.5.5 0 1 0-1 0v6a.5.5 0 1 0 1 0zm11.18 0a.5.5 0 1 0-1 0v6a.5.5 0 1 0 1 0zm-2.59 8.59a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 .5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeAll16);
